export default __webpack_public_path__ + "static/media/personal-check.3e23ed01.svg";